import { createSlice } from "@reduxjs/toolkit";

const tabs = [
    {
        id : 1 , 
        name : 'Compaign Details'
    } ,
    {
        id : 2 , 
        name : 'Geo Location'
    } ,
    {
        id : 3 , 
        name : 'Additional Targeting'
    } ,
    {
        id : 4 , 
        name : 'Schedule ads'
    } ,
    {
        id : 5 , 
        name : 'Ad Content'
    } ,
    {
        id : 6 , 
        name : 'KPI Report'
    } ,
]

const newCompaignSlice = createSlice({
    name : 'newCompaign' ,
    initialState : {
        tabs  ,
        selectedTab : tabs[0] , 
        nextTab : tabs[1] ,
        prevTab : null , 
        stepperWidth: 16.6 ,
    } ,
    reducers : {
        setSelectedTab (state , action) {
            state.selectedTab = action.payload;
        } ,
        setNextTab (state , action) {
            state.nextTab = action.payload;
        } ,
        setPrevTab (state , action) {
            state.prevTab = action.payload 
        } ,
        setStepperWidth (state , action) {
            state.stepperWidth = action.payload;
        }
    }
});

export const { setSelectedTab , setNextTab , setPrevTab , setStepperWidth } = newCompaignSlice.actions;



export default newCompaignSlice.reducer;